import { InvertedCorner } from "../NordenNavbar"

const ImageAbout = () => {
   return (
      <div className="max-w-xl w-full p-2 mt-3 mb-3 h-60 flex items-center relative justify-center rounded-md bg-gradient-to-bl from-neutral-200 to-zinc-300 shadow-inner shadow-neutral-200">
         <img src="https://i.ibb.co/nMR70fNF/profileimg.png" alt="profileImage" className="size-40 outline-none mx-auto" />

         <div className="absolute right-0 bottom-0 px-4 py-2 text-lg font-mono bg-white rounded-tl-2xl">
            <div className="relative ">
               <div className="font-medium items-center hover:text-yellow-400 transition-all duration-200 delay-150 flex gap-3">Arvaz 
                  <span>
                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L14.012 7.23109C14.294 7.96432 14.435 8.33093 14.6542 8.63931C14.8486 8.91262 15.0874 9.15141 15.3607 9.34575C15.6691 9.56503 16.0357 9.70603 16.7689 9.98804L22 12L16.7689 14.012C16.0357 14.294 15.6691 14.435 15.3607 14.6542C15.0874 14.8486 14.8486 15.0874 14.6542 15.3607C14.435 15.6691 14.294 16.0357 14.012 16.7689L12 22L9.98804 16.7689C9.70603 16.0357 9.56503 15.6691 9.34575 15.3607C9.15141 15.0874 8.91262 14.8486 8.63931 14.6542C8.33093 14.435 7.96432 14.294 7.23109 14.012L2 12L7.23108 9.98804C7.96431 9.70603 8.33093 9.56503 8.63931 9.34575C8.91262 9.15141 9.15141 8.91262 9.34575 8.63931C9.56503 8.33093 9.70603 7.96431 9.98804 7.23108L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     </svg>
                  </span>
               </div>

               <InvertedCorner className="absolute -right-4 -top-8 text-white" />
               <InvertedCorner className="absolute -left-10 top-3 text-white" />
            </div>
         </div>
      </div>
   )
}

export default ImageAbout
